export const COUNTRIES = [
  'United States',
  'Canada',
  'Republic of Korea',
  'France',
  'Spain',
  'Hungary',
  'Italy',
  'Romania',
  'Switzerland',
  'Austria',
  'United Kingdom',
  'Sweden',
  'Poland',
  'Germany',
  'Mexico',
  'Brazil',
  'Indonesia',
  'Japan',
  'Korea',
  'Vietnam',
  'China',
  'Turkey',
  'India',
  'Luxembourg',
  'Serbia',
  'Montenegro',
  'Czech Republic',
  'Slovakia',
];

export const CLIENT_CORPORATES = [
  {
    corporate_name_ko: 'HL만도 국내',
    corporate_name_en: 'HL Mando Korea',
    corporate_name_zh: 'HL Mando 韩国',
  },
  {
    corporate_name_ko: 'HL만도 중국',
    corporate_name_en: 'HL Mando China',
    corporate_name_zh: 'HL Mando 中国',
  },
  {
    corporate_name_ko: 'HL만도 인도',
    corporate_name_en: 'HL Mando India',
    corporate_name_zh: 'HL Mando 印度',
  },
  {
    corporate_name_ko: 'HL만도 말레이지아',
    corporate_name_en: 'HL Mando Malaysia',
    corporate_name_zh: 'HL Mando 马来西亚',
  },
  {
    corporate_name_ko: 'HL만도 미국',
    corporate_name_en: 'HL Mando USA',
    corporate_name_zh: 'HL Mando 美国',
  },
  {
    corporate_name_ko: 'HL만도 브라질',
    corporate_name_en: 'HL Mando Brazil',
    corporate_name_zh: 'HL Mando 巴西',
  },
  {
    corporate_name_ko: 'HL만도 멕시코',
    corporate_name_en: 'HL Mando Mexico',
    corporate_name_zh: 'HL Mando 墨西哥',
  },
  {
    corporate_name_ko: 'HL만도 폴란드',
    corporate_name_en: 'HL Mando Poland',
    corporate_name_zh: 'HL Mando 波兰',
  },
  {
    corporate_name_ko: 'HL만도 터키',
    corporate_name_en: 'HL Mando Turkey',
    corporate_name_zh: 'HL Mando 土耳其',
  },
  {
    corporate_name_ko: 'HL클레무브/HL만도브로제 (인천, 천안)',
    corporate_name_en: 'HL Klemove / HL Mando Brose (Incheon, Cheonan)',
    corporate_name_zh: 'HL Klemove / HL Mando Brose（仁川、天安）',
  },
];

export const SITE_INIT_INFO = {
  site_name: null,
  site_country: null,
  site_address: null,
  site_clients: [],
};

export const MOCK_SITE_USERS = [
  {
    id: 1,
    company_name: '(협력사 기업명)',
    username: '참여자 1',
    email: 'user1@company.co.kr',
    phone: '010-1111-2222',
    'current-password': '!qesg2493',
    'new-password': null,
    'new-password-confirm': null,
  },
  {
    id: 2,
    company_name: '(협력사 기업명)',
    username: '참여자 2',
    email: 'user2@company.co.kr',
    phone: '010-1111-2222',
    'current-password': '!qesg2493',
    'new-password': null,
    'new-password-confirm': null,
  },
  {
    id: 3,
    company_name: '(협력사 기업명)',
    username: '참여자 3',
    email: 'user3@company.co.kr',
    phone: '010-1111-2222',
    'current-password': '!qesg2493',
    'new-password': null,
    'new-password-confirm': null,
  },
];

export const STYLE_CONSTANTS = {
  DESC_STYLE_HEADER: {
    fontWeight: 500,
    fontSize: '15px',
    backgroundColor: '#fafafa',
  },
  DESC_STYLE_BODY: {
    fontSize: '13.5px',
  },
};